import React from 'react';
import './style.css';

class Aba extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        
    }
  }
  render(){
    return <div>
        <p>
         Minhas Rede Sociais:
         <br/><br/>
         <a href="https://www.youtube.com/channel/UC-neZ4NvxLY5eRLPQTgO7OQ" target="_blank">
         YouTube
         </a>
         <a href="https://www.moddb.com/members/luizf34" target="_blank">
         Mod DB
         </a>
         <a href="https://steamcommunity.com/id/luizf34" target="_blank">
           Steam
         </a>
        </p>
    </div>
  };
}

export default Aba;